import { GET, GET_WARRANTY_INFO_CODE } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { toUploadFileList } from '../../../../functions/imageUpload';
import { useState } from 'react';
import { useEffect } from 'preact/hooks';

export const useGetWarrantyEdit = ({ warrantyCode, reset, setProducts }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_WARRANTY_INFO_CODE(warrantyCode));
      return response.result;
    },
    onSuccess: (result) => {
      reset({
        ...result?.warranty,
        invImageUrl: toUploadFileList(result?.warranty?.invImageUrl),
        packageImageUrl: toUploadFileList(result?.warranty?.packageImageUrl),
      });
      setProducts(result?.item?.mobilebrands);
      setData(result);
    },
  });

  useEffect(() => {
    if (warrantyCode) {
      mutate();
    }
  }, [warrantyCode]);

  return { dataSource: data, setData, onSearch: mutate, loading: isPending };
};
